import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getAllTags({ commit }) {
    let response = await requestAxios({
      url: "/awy/api/v1/tags",
      method: "GET",
    });
    commit(MutationsType.SET_TAGS, response.data.data);
  },
  async createTag({ commit }, { tag }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/tags",
        method: "POST",
        data: tag,
      });
      commit(MutationsType.ADD_TAG, response.data.data);
      return response.data;
    } catch (error) {
      console.error("createTag: ", error.response.data);
      throw error.response.data;
    }
  },
  async updateTag({ commit }, { tag }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/tags/${tag.id}`,
        method: "PUT",
        data: tag,
      });
      commit(MutationsType.UPDATE_TAG, response.data.data);
      return response.data;
    } catch (error) {
      console.error("updateTag: ", error.response.data);
      throw error.response.data;
    }
  },
  async removeTag({ commit }, { tag }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/tags/${tag.id}`,
        method: "DELETE",
        data: tag,
      });
      commit(MutationsType.REMOVE_TAG, response.data.data);
      return response.data;
    } catch (error) {
      console.error("removeTag: ", error.response.data);
      throw error.response.data;
    }
  },
  resetModuleTag({ commit }) {
    commit(MutationsType.SET_TAGS, null);
  },
};
